import {
	getSuppliersAll
} from '@/api/goods';

import Pagination from '@/components/Pagination';

export default {
	name: 'shares',
    components: {
		Pagination
	},
	data() {
		return {
			orderObj: { //订单列表
				list: [],
				total: 0,
				listLoading: false,
			},
            payDate: [],
			form: {
				pageNum: 1,
				pageSize: 100,
			}
		}
	},
	beforeCreate() {
        
	},
	created() {
		this.getOrderPage()
	},
	methods: {
		//获取订单列表
		getOrderPage() {

            if(this.payDate){
                this.form.startTimeYMD = this.payDate[0]
                this.form.endTimeYMD = this.payDate[1]
            }else{
                this.form.startTimeYMD = ''
                this.form.endTimeYMD = ''
            }
            this.orderObj.listLoading = true;
			//获取订单列表
			getSuppliersAll(this.form).then(res => {
				this.orderObj.list = res.data;
                this.orderObj.total = res.data.total;
				this.orderObj.listLoading = false;

			})

		},
	}
}
